import React from "react";
import { Box, Button, Flex, Tag, Text } from "@chakra-ui/react";
import { formatDate } from "utils/dateUtils/dateUtils";

interface CardProps {
  item: any;
  handleOpenModal: any;
  findBuyerNameByBapId: any;
  index: number;
}

export default function ReconciliationCardView({
  item,
  handleOpenModal,
  findBuyerNameByBapId,
  index,
}: CardProps):JSX.Element {
  return (
    <>
      <Box
        key={index}
        p={4}
        mb={4}
        borderRadius="md"
        bg="white"
        shadow="base"
        onClick={() => handleOpenModal(item)}
      >
        <Flex justify="space-between">
          <Text fontWeight={500} color={"blue.500"}>
            {item?.order_id}
          </Text>
          <Tag
            size={"sm"}
            colorScheme={
              item.status === "RECONCILED"
                ? "green"
                : item.status === "PENDING"
                ? "orange"
                : "red"
            }
          >
            {item.status}
          </Tag>
        </Flex>
        <Text isTruncated={true} w={"8rem"}>
          Buyer: {findBuyerNameByBapId(item?.bap_id)}
        </Text>
        <Text>Seller Fare: {item?.price_from_seller}</Text>
        <Text>AFCS Fare: {item?.price_from_adaptor}</Text>
        <Text>Order Date: {formatDate(item?.order_time)}</Text>
        <Button mt={2} colorScheme="teal" onClick={() => handleOpenModal(item)}>
          View Details
        </Button>
      </Box>
    </>
  );
}
